import { HttpClient, HttpHeaders, HttpBackend } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class AbhaService {
  private httpDirect: HttpClient;

  constructor(private httpBackend: HttpBackend) {
    this.httpDirect = new HttpClient(this.httpBackend);
  }

  linkCareContextV3(data: {
    abhaNumber: string;
    abhaAddress: string;
    tenantId: string;
    branchId?: string;
    token: string;
    requestId: string;
    accessToken: string;
    abhaBaseURL: string;
    visitIds: any[];
    patients: any[];
    regId:string;
  }): Observable<any> {

    const url = data.abhaBaseURL + 'carecontext/auth/add-contextV3';

    const body = {
      abhaNumber: data.abhaNumber,
      abhaAddress: data.abhaAddress,
      tenantId: data.tenantId,
      branchId: data.branchId,
      visitIds: data.visitIds,
      patient: data.patients,
      regId:data.regId
    };

    const headers: HttpHeaders = new HttpHeaders()
      .append('Content-Type', 'application/json')
      .append('Authorization', 'Bearer ' + data.token)
      .append('Accept', '*/*')
      .append('REQUEST-ID', data.requestId.toString())
      .append('TIMESTAMP', new Date().toISOString())
      .append('X-LINK-TOKEN', data.accessToken);

    return this.httpDirect.post(url, JSON.stringify(body), { headers });
  }
}